<template>
  <div >
    <el-row :gutter="20" style="margin-bottom:10px;">
      <el-col>
        <span class="fs-14 secondary-text">{{ $t('common.total') }} : {{stats.count}} </span>
        <span class="fs-14 secondary-text" style="margin-left:20px;" v-if="isFiltered">{{ $t('common.totalFiltered') }} : {{count}} <el-link type="text" @click="resetFilters"><i class="mdi mdi-filter-remove"/></el-link></span>
      </el-col>
    </el-row>
    <div style="margin:10px;">
      <el-input
        :placeholder="$t('reservation.findReservation')"
        clearable
        v-model="search"
        v-popover:popover>
        <el-dropdown slot="append" style="border-right:1px;">
            <el-button type="primary">
            {{ $t('common.sortBy') }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :icon="sortIcon('customer.name')" @click.native="sortBy('customer.name')">{{ $t('reservation.customer') }}</el-dropdown-item>
            <el-dropdown-item  :icon="sortIcon('created_at')" @click.native="sortBy('created_at')">{{ $t('reservation.reservationDate') }}</el-dropdown-item>
            <el-dropdown-item  :icon="sortIcon('updated_at')" @click.native="sortBy('updated_at')">{{ $t('reservation.lastModification') }}</el-dropdown-item>
            <el-dropdown-item  :icon="sortIcon('nbDays')" @click.native="sortBy('nbDays')">{{ $t('reservation.nbDays') }}</el-dropdown-item>
            <el-dropdown-item  :icon="sortIcon('provider')" @click.native="sortBy('product')">{{ $t('reservation.product') }}</el-dropdown-item>
            <el-dropdown-item  :icon="sortIcon('provider')" @click.native="sortBy('provider')">{{ $t('reservation.provider') }}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <el-button slot="prepend" @click="showFilters=true"><i class="mdi mdi-filter-variant" style="font-size:15px;"></i></el-button>
      </el-input>
    </div>
    <div class="box grow item-list no-p" :style="getHeightStyle" v-loading="loading" v-if="mode=='tile'">
      <div class="infinite-list" v-infinite-scroll="load" :infinite-scroll-distance="0" infinite-scroll-distance="400" style="overflow:auto;" :style="getHeightStyle">
        <div v-for="(r, index) in reservations" :key="r.id" class="flex item" style="margin:10px;" :class="{ active : (selectedReservation!=null && selectedReservation.id == r.id) }" @click="$emit('select',index);">
          <div v-if="count==0 && isFiltered()">{{ $t('reservation.noReservationCriterias') }}</div>
          <reservationTile
            :reservation="r"
            :showSalesRep="r.sales_rep!=null" />
        </div>
      </div>
    </div>
    <div v-else>
      <el-table
      :data="reservations"
      stripe
      v-loading="loading"
      :height="getHeight"
      :cell-style="{padding:'2px'}"
      :empty-text="$t('reservation.noReservationCriterias')"
      style="width: 100%">
      <el-table-column
        prop="date"
        :label="$t('common.date')"
        show-overflow-tooltip
        fixed
        width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.date">{{moment(scope.row.date,'DD-MM-YYYY')}}</span>
          <span v-if="scope.row.delayed">{{ $t('reservation.toCome') }}</span>
          <span v-if="scope.row.intent">{{ $t('reservation.intent') }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        :label="$t('reservation.reservationNumber')"
        fixed
        width="100">
        <template slot-scope="scope">
          <i v-if="!qtyValid(scope.row)" class="mdi mdi-alert">&nbsp;</i>
          <PortausLink :id="scope.row.id" path="/reservations/" :label="scope.row.id.toString()"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        fixed
        text-align="center"
        width="50">
        <template slot-scope="scope">
           <span v-if="isB2B(scope.row)" class="ml-5 fs-14 secondary-text">
              <el-image src="/logo-panorama.png" style="height:16px;"></el-image>
            </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="customer.name"
        show-overflow-tooltip
        :label="$t('reservation.customer')">
        <template slot-scope="scope">
          <PortausLink :id="scope.row.customer.id" path="/customers/" :label="getCustomerName(scope.row.customer)"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column
        prop="product.name"
        show-overflow-tooltip
        :label="$t('reservation.productName')">
        <template slot-scope="scope">
          <el-link  type="primary" @click="openProductDrawer(scope.row.puid, scope.row.fk_inventory_id)">{{scope.row.product.name}}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        :label="$t('products.format')">
        <template slot-scope="scope">
          <UnitFormatVolumeLabel
            class="ml-5 mb-3"
            :unit="scope.row.product.unit"
            :uvc="scope.row.product.uvc"
            :format="scope.row.product.format"
            :volume="scope.row.product.volume" />
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        :label="$t('reservation.provider')">
        <template slot-scope="scope">
          <PortausLink v-if="scope.row.product.provider != null" :id="scope.row.product.provider.id" path="/customers/" :label="scope.row.product.provider.name"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column
        prop="quantity.qty_reserved"
        show-overflow-tooltip
        :label="$t('reservation.qtyReservedField')"
        width="100">
        <template slot-scope="scope">
          {{scope.row.quantity.qty_reserved}}
        </template>
      </el-table-column>
      <el-table-column
        prop="quantity.limit_date"
        show-overflow-tooltip
        :label="$t('reservation.limitDate')"
        width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.limit_date != null">{{moment(scope.row.limit_date)}}</span>
          <span v-else> -- </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="quantity.qty_used"
        show-overflow-tooltip
        :label="$t('reservation.qtyUsed')"
        width="100">
        <template slot-scope="scope">
          {{scope.row.quantity.qty_used}}
        </template>
      </el-table-column>
      <el-table-column
        prop="quantity.qty_available"
        show-overflow-tooltip
        :label="$t('reservation.qtyAvailable')"
        width="100">
        <template slot-scope="scope">
          <span v-if="!scope.row.delayed && !scope.row.intent">{{scope.row.quantity.qty_available}}</span>
          <span v-else>{{ $t('common.notAvailable') }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="nb_days"
        show-overflow-tooltip
        :label="$t('reservation.age')"
        width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.date && showDelayIndicator(scope.row)">{{scope.row.nb_days}} {{$t('reservation.days')}}</span>
          <span v-else> -- </span>
        </template>
      </el-table-column>
      <infinite-loading
        slot="append"
        ref="infiniteLoading"
        @infinite="load"
        force-use-infinite-wrapper=".el-table__body-wrapper">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </el-table>
    </div>
    <ProductDetailDrawer :puid="selectedPuid"  direction="ltr" :visible="productDetailDrawerVisible" @close="closeProductDetailDrawer"></ProductDetailDrawer>
    <reservationFilter :visible="showFilters" direction="ltr" @close="showFilters=false"></reservationFilter>
  </div>
</template>
<script>
  import { mapActions, mapState, mapGetters } from 'vuex';
  import PortausLink from '@/components/portaus-link'
  import moment from 'moment-timezone'
  import CustomerUtil from '@/utils/customer-util.js'
  import reservationTile from '@/components/reservation/reservation-tile'
  import reservationFilter from './reservation-filter'
  import ProductDetailDrawer from '@/views/pages/inventory/components/product-detail-drawer'
  import reservationAPI from '@/services/API/reservation'
  import ReservationUtil from '@/utils/reservation-util'
  import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel';
  export default {
    name: 'Reservations-List',
    props: {

  	},
    data() {
      return {
        window: {
          width: 0,
          height: 0
        },
        showFilters:false,
        selectedPuid :null,
        selectedInventoryId : null,
        productDetailDrawerVisible :false,
        stats : {
          count  :0
        }
      };
    },components: {
      reservationTile,
      reservationFilter,
      PortausLink,
      ProductDetailDrawer,
      UnitFormatVolumeLabel,
    },
    watch : {

    },
  	methods: {
      isB2B(reservation) {
        if (reservation.origin === 'B2B') {
          return true;
        }
      },
      showDelayIndicator(reservation) {
        let show = true;

        if (reservation.intent === false && reservation.delayed === false && reservation.quantity.qty_available <= 0) {
          show = false;
        }
        return show;
      },
      qtyValid (reservation) {
        return ReservationUtil.isQuantityValid(reservation);
      },
      getCustomerName(customer){
        return CustomerUtil.customerName(customer.name, customer.usual_name);
      },
      load($state) {
  			if(this.page <= this.pages){
  				this.fetchNextReservationsPage()
  					.then(()=>{
  						if($state){
  							$state.loaded();
  						}
  					})
  			}else{
  				if($state)$state.complete();
  			}
      },
  		loadCount(){
  			reservationAPI.fetchReservations({count:''})
  				.then(stats=>{
  					this.stats.count = stats.count;
  				})
  		},
      handlePageChange(val){
        this.changePage(val);
      },
      sortBy(orderName){
        if(this.orderBy.orderName!=orderName){
          this.orderBy={orderName : orderName, direction:'ASC'};
          this.sort_icon = this.icons['ASC'];
        }else{
          if(this.orderBy.direction=='DESC'){
            this.orderBy={orderName : orderName, direction:'ASC'};
            this.sort_icon = this.icons['ASC'];
          }else{
            this.orderBy={orderName : orderName, direction:'DESC'};
            this.sort_icon = this.icons['DESC'];
          }
        }
      },
      sortIcon(orderName){
        return orderName==this.orderBy.orderName?this.sort_icon:'';
      },
      moment(datetime,format='LL'){
        if(datetime!=null){
          return  moment(datetime).format(format);
        }else return "";

  		},
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      },
      openProductDrawer(puid, inventoryId){
        this.selectedPuid = puid;
        this.selectedInventoryId = inventoryId;
        this.productDetailDrawerVisible = true;
      },
      closeProductDetailDrawer(){
        this.selectedProductId = null;
        this.selectedInventoryId = null;
        this.productDetailDrawerVisible = false;
      },
      ...mapActions('reservations', ['setSearchTerms','changeOrderBy','changeSortIcon','changePage','fetchNextReservationsPage','resetFilters']),
      ...mapGetters('reservations', ['getOrderBy', 'getSortIcon','isFiltered'])

  	},
  	computed: {
      orderBy : {
  			set(val){this.changeOrderBy(val)},
  			get(){return this.getOrderBy()}
  		},
      sort_icon : {
  			set(val){this.changeSortIcon(val)},
  			get(){return this.getSortIcon()}
  		},
      search : {
          set(val){ this.setSearchTerms(val)},
          get(){return this.searchTerms}
      },
      getHeight(){
  			return (this.window.height-300);
  		},
      getHeightStyle(){
        return "height:" + (this.window.height-242) + "px;";
      },
      ...mapState('reservations', ['mode','reservations','searchTerms','loading','selectedReservation','icons', 'salesOrders','page','pages','limit','count']),
      ...mapGetters('reservations',['isPositive','isNegative','isIntermediary','isActive','customerName','isQuantityValid'])
  	},
    mounted(){
      this.loadCount();
    },
  	created(){
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';


  .active{
    background-color: lighten($background-color, 20%);
    border-radius: 5px;
    box-shadow:none;
    box-shadow: 0 4px 8px 0 rgba(40,40,90,.09),0 1px 3px 0 rgba(0,0,0,.065);
  }


  .item-list {
    //margin: 0 auto;
    width: 100%;
    padding: 0px 30px;
    box-sizing: border-box;

    .item {
      margin: 10px 0;
      padding: 5px;
      box-sizing: border-box;
      cursor: pointer;
      transition: all .5s .25s;


      .info {
        word-break: break-word;

      }

      &:hover {
        //margin: 15px -20px;
        //padding: 10px;
        background-color: lighten($background-color, 20%);
        border-radius: 5px;
        box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

      }

    }
  }

  </style>
